import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Box, Typography } from '@mui/material';

const CustomBtnSelect = (props) => {
  const {
    options,
    label,
    action,
    onClick,
    className = '',
    selected = null,
    labelError = false,
    labelStyle= {},
    children,
    persist,
    flexDirection = 'row',
    ...rest
  } = props;
  const [active, setActive] = useState(selected);

  useEffect(() => {
    if (selected !== active) {
      setActive(selected);
    }
  }, [selected]);

  const setOption = (option) => {
    const selected = active === option;
    !action && setActive(selected ? null : option);
  };

  const labelStyles = labelError
    ? {
        color: '#FF0404',
        fontWeight: 500,
        ...labelStyle,
      }
    : {};
    
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5, my: 0.5 }}>
      <Typography variant="body2">{label}</Typography>
      <Box flexDirection={flexDirection} sx={{ display: 'flex', justifyContent: 'center', gap: 1, width: options.length === 1 ? '100%' : 'fit-content' }}>
        {options.map((option) => {
          const isActive = !action && active === option;
          return (
              <Button
                {...rest}
                style={{ 
                  borderRadius: 20, 
                  ...(rest.color === 'success' && !isActive ? { backgroundColor: 'white' } : {})
                }}
                key={option}
                fullWidth={options.length === 1}
                variant={isActive ? 'contained' : 'outlined'}
                onClick={(e) => {
                  const same = persist && (active === option)
                  if (e.detail === 0 || same) return;
                  setOption(option);
                  onClick(option, e);
                }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', my: '4px' }}>
                  {option}
                  {children}
                </Box>
              </Button>
          );
        })}
      </Box>
    </Box>
  );
};

CustomBtnSelect.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
  action: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  selected: PropTypes.oneOfType([
    null,
    PropTypes.bool,
    PropTypes.string,
  ]),
  persist: PropTypes.bool,
};

export default CustomBtnSelect;
